import styled, { css } from 'styled-components'
import check from '../../../../assets/addStockModal/pages/check.svg'
import cross from '../../../../assets/addStockModal/pages/cross.svg'

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
`

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 62vw;
  margin-top: 2.8vh;
  margin-left: 1.5vw;
  margin-right: 1vw;
`

export const HeaderText = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.4vw;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0;
`

export const CloseDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2vw;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;

  :hover {
    background-color: #f4f4f4;
  }
`

export const CloseImg = styled.img`
  width: 0.8vw;
`

export const ProgressBarDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2.8vh;
  margin-left: 0.1vw;
  margin-right: 0.1vw;

  .active {
    background-color: #0090d3;
  }
`

export const ProgressBarCircle = styled.div`
  width: 1vw;
  height: 1vw;
  border-radius: 2vw;
  background-color: #c4c4c4;
`

export const ProgressBarLine = styled.div`
  width: 29vw;
  height: 0.5vh;
  background-color: #c4c4c4;
`

export const Phrase = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  margin-left: 0.7vw;
  line-height: 18.46px;
  color: #777777;
  padding: 0px 10px 0px 10px;
`

export const SwitchesDiv = styled.div`
  display: flex;
  margin-top: 3vh;
  align-items: center;
  justify-content: space-between;
  margin-left: 1.5vw;
  margin-right: 4vw;
`

export const SwitchDiv = styled.div`
  display: flex;
  flex-direction: column;
`

export const SwitchLabel = styled.label`
  font-weight: 700;
  font-size: 0.9vw;
  font-family: 'Inter', sans-serif;
`

export const SwitchBox = styled.label`
  display: inline-block;
  position: relative;
  margin-top: 1vh;
  width: 60px;
  height: 34px;
`

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  :checked + .slider {
    background-color: #2196f3;
    border: 0;
    padding: 2px;
  }

  :focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }

  :checked + .slider:before {
    background-image: url(${check});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 15px 15px;
    background-color: #fff;
    -webkit-transform: translateX(24px);
    -ms-transform: translateX(24px);
    transform: translateX(24px);
  }
`

export const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  border: #696969 2px solid;

  :before {
    display: block;
    position: relative;
    content: '';
    height: 24px;
    width: 24px;
    left: 5.5px;
    top: 2.8px;
    background-color: #696969;
    border-radius: 50%;
    transition: all 0.4s;
    background-image: url(${cross});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 11px 11px;
  }
`

export const MappingArea = styled.div`
  background-color: #fff;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  margin: 18px 15px 0px 15px;
  width: 53rem;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    cursor: pointer;
  }

  ::-webkit-scrollbar-thumb {
    background: #ffffff; /* Cor do scrollbar */
    border-radius: 3px; /* Border radius do scrollbar */
  }

  ::-webkit-scrollbar-track {
    background: #e1e1e1; /* Cor de fundo do scrollbar */
    border-radius: 3px; /* Border radius do scrollbar */
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555; /* Cor da barra de rolagem ao passar o mouse por cima */
  }
`

export const RowsDiv = styled.div`
  width: 3280px;
  padding-left: 0.2vw;
  padding-top: 1vh;
  padding-bottom: 1vh;
  border: 2px solid #f4f4f4;
  border-radius: 1vw;
`

export const RowDiv = styled.div`
  display: flex;
  height: 6vh;
  padding-top: 0.5vh;
  padding-bottom: 0.5vh;
  align-items: center;
`

export const RowText = styled.p`
  position: relative;
  bottom: 0.4vh;
  font-size: 0.9vw;
  font-family: 'Inter', sans-serif;
  color: #777777;
  width: 5vw;
  margin-left: 1vw;
  margin-right: 3vw;
  margin-top: 0;
  margin-bottom: 0;
`

export const RowFieldDiv = styled.div`
  display: flex;
  align-items: center;
`

export const PreviewText = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 1.2vw;
  margin-top: 3vh;
  margin-bottom: vh;
  margin-left: 0.5vw;
  margin-right: 0;
`

export const Preview = styled.table`
  color: #696969;
  border-collapse: collapse;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  margin-top: 1.5vh;
  background-color: #ffffff;
  width: 100%;

  tr:nth-child(2) td:first-child {
    border-top-left-radius: 0.8vw;
  }

  tr:nth-child(2) td:last-child {
    border-top-right-radius: 0.8vw;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 0.8vw;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 0.8vw;
  }
`

export const TableBody = styled.tbody`
  display: flex;
  flex-direction: column;
`

export const HeaderRow = styled.tr`
  display: flex;
`

export const HeaderCell = styled.th`
  display: flex;
  background-color: #fff;
  width: 125.2px;
  padding: 10px 10px 10px 20px;
`

export const ItemRow = styled.tr`
  display: flex;
`

export const ItemCell = styled.td`
  background-color: #f4f4f4;
  width: 125.2px;
  padding: 10px 10px 10px 20px;
`

export const ButtonsDiv = styled.div`
  display: flex;
  margin-top: 3vh;
  align-items: center;
  margin-left: 39vw;
`

export const CancelButton = styled.button`
  width: 8vw;
  height: 5.8vh;
  background-color: #fff;
  color: #0090d3;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  border: 0;
  cursor: pointer;
`

export const PreviousButtonDiv = styled.div`
  display: flex;
  align-items: center;
  width: 6.5vw;
  height: 5.8vh;
  background-color: #fff;
  color: #0090d3;
  border: solid #0090d3 1px;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border-radius: 3vw;
  cursor: pointer;
`

export const PreviousButtonImage = styled.img`
  margin-left: 1vw;
  width: 0.9vw;
`

export const PreviousButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-left: 0.6vw;
`

export const NextButtonDiv = styled.div`
  display: flex;
  align-items: center;
  width: 8vw;
  height: 5.8vh;
  background-color: #0090d3;
  color: #fff;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border-radius: 3vw;
  cursor: pointer;
`

export const NextButtonImage = styled.img`
  margin-left: 1vw;
  width: 0.9vw;
`

export const NextButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-left: 0.6vw;
`

export const DisabledNextButtonDiv = styled.div`
  display: flex;
  align-items: center;
  width: 8vw;
  height: 5.8vh;
  background-color: #ebebeb;
  color: #c4c4c4;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border-radius: 3vw;
  cursor: not-allowed;
`

export const DisabledNextButtonImage = styled.img`
  margin-left: 1vw;
  width: 0.9vw;
`

export const DisabledNextButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-left: 0.6vw;
`

// export const NextButton = styled.button`
//   position: relative;
//   left: 410px;
//   width: 120px;
//   background-color: #6ec1e4;
//   color: #ffffff;

//   justify-content: center;
//   align-items: center;
//   display: flex;

//   height: 36px;

//   margin: 20px 0 0 0;

//   border: 2px solid #6ec1e4;
//   border-radius: 3px;

//   :hover {
//     background-color: #1f9dd4;
//     cursor: pointer;
//   }

//   @media (min-width: 1200px) {
//     font-size: 14px;
//   }

//   @media (max-width: 1200px) {
//     font-size: 13px;
//   }

//   @media (max-width: 992px) {
//     font-size: 12px;
//   }

//   @media (max-width: 768px) {
//     font-size: 11px;
//   }

//   @media (max-width: 600px) {
//     font-size: 8px;
//   }
// `

// export const BackButton = styled.button`
//   position: relative;
//   left: 400px;
//   width: 120px;
//   background-color: #ffffff;
//   color: #6ec1e4;

//   justify-content: center;
//   align-items: center;
//   display: flex;

//   height: 36px;

//   margin: 20px 0 0 0;

//   border: 2px solid #6ec1e4;
//   border-radius: 3px;

//   :hover {
//     background-color: #e1e1e199;
//     cursor: pointer;
//   }

//   @media (min-width: 1200px) {
//     font-size: 14px;
//   }

//   @media (max-width: 1200px) {
//     font-size: 13px;
//   }

//   @media (max-width: 992px) {
//     font-size: 12px;
//   }

//   @media (max-width: 768px) {
//     font-size: 11px;
//   }

//   @media (max-width: 600px) {
//     font-size: 8px;
//   }
// `

// export const CancelButton = styled.button`
//   position: relative;
//   left: 1rem;
//   width: 160px;
//   background-color: #ffffff;
//   color: #ff000099;

//   justify-content: center;
//   align-items: center;
//   display: flex;

//   height: 36px;

//   margin: 20px 0 0 0;

//   border: 2px solid #77777777;
//   border-radius: 3px;

//   :hover {
//     background-color: #e1e1e199;
//     cursor: pointer;
//   }

//   @media (min-width: 1200px) {
//     font-size: 14px;
//   }

//   @media (max-width: 1200px) {
//     font-size: 13px;
//   }

//   @media (max-width: 992px) {
//     font-size: 12px;
//   }

//   @media (max-width: 768px) {
//     font-size: 11px;
//   }

//   @media (max-width: 600px) {
//     font-size: 8px;
//   }
// `

// export const DisabledNextButton = styled.button`
//   position: relative;
//   left: 410px;
//   width: 120px;
//   background-color: #b5b5b5;
//   color: #ffffff;

//   justify-content: center;
//   align-items: center;
//   display: flex;

//   height: 36px;

//   margin: 20px 0 0 0;

//   border: 2px solid #b5b5b5;
//   border-radius: 3px;

//   @media (min-width: 1200px) {
//     font-size: 14px;
//   }

//   @media (max-width: 1200px) {
//     font-size: 13px;
//   }

//   @media (max-width: 992px) {
//     font-size: 12px;
//   }

//   @media (max-width: 768px) {
//     font-size: 11px;
//   }

//   @media (max-width: 600px) {
//     font-size: 8px;
//   }
// `

// export const ButtonsArea = styled.div`
//   display: flex;
// `
